import { BusinessProfileUpdateStrategy } from '../../../../providers/BusinessProfileProvider';

export default {
  modals: {
    update_strategy: {
      title: 'Ce locații trebuie actualizate?',
      form: {
        update_strategy: {
          options: {
            [BusinessProfileUpdateStrategy.All]: 'Toate locațiile mele',
            [BusinessProfileUpdateStrategy.Current]: 'Doar locația selectată curent',
          },
        },
      },
      buttons: {
        confirm: 'Confirmați',
      },
    },
  },
  toasts: {
    error: 'Ceva nu a funcționat, vă rugăm să încercați din nou sau să contactați suportul tehnic',
    success: 'Modificările au fost salvate cu succes!',
  },
};
